module.exports = __webpack_public_path__ + "img/Rear glass.7459b088.png";